import {ThemeConfig} from 'antd';
import {brandConfig} from './libs/ui/src';

export const theme: ThemeConfig = {
  inherit: false,
  token: {
    colorPrimary: brandConfig?.primaryColor,
    colorText: '#777',
  },
  components: {
    Input: {
      borderRadius: 5,
    },
    Menu: {
      itemHoverColor: brandConfig?.primaryColor,
      itemHoverBg: 'unset',
      subMenuItemBg: 'unset',
    },
  },
};

export const authTheme: ThemeConfig = {
  ...theme,
  token: {
    ...theme.token,
    colorText: '#000',
  },
  components: {
    ...theme.components,
    Input: {
      ...theme.components?.Input,
      borderRadius: brandConfig?.borderRadius ?? theme.components.Input.borderRadius,
    },
    Button: {
      ...theme.components?.Button,
      borderRadius: brandConfig?.borderRadius ?? theme.components.Input.borderRadius,
    },
    Select: {
      ...theme.components?.Select,
      borderRadius: brandConfig?.borderRadius ?? theme.components.Input.borderRadius,
    },
  },
};
